export const categoriesTranslations: Record<string, {
  title: string;
  description: string;
  card_title: string;
  card_description: string;
  card_description_suffix: string;
  income_categories: string;
  expense_categories: string;
  click_to_edit: string;
  category_name: string;
  category_item: string;
  category_subitem_optional: string;
  add_income_category: string;
  add_expense_category: string;
  save: string;
  empty_state_title: string;
  empty_state_description: string;
  initialize_template: string;
}> = {
  pt: {
    title: "Categorias",
    description: "Gerir categorias de receitas e despesas para organizar transações",
    card_title: "Categorizar transações",
    card_description: "Defina Categorias de Receita e Despesa",
    card_description_suffix: "para manter receitas e despesas organizadas.",
    income_categories: "Categorias de Receitas",
    expense_categories: "Categorias de Despesas",
    click_to_edit: "(Clique no nome da categoria para editar)",
    category_name: "Nome da categoria",
    category_item: "Item",
    category_subitem_optional: "Sub-item (opcional)",
    add_income_category: "Adicionar categoria de receita",
    add_expense_category: "Adicionar categoria de despesa",
    save: "Guardar",
    empty_state_title: "Comece com um template de categorias",
    empty_state_description: "Criamos categorias padrão para a sua organização.",
    initialize_template: "Inicializar categorias",
  },
  en: {
    title: "Categories",
    description: "Manage income and expense categories for transaction organization",
    card_title: "Categorize transactions",
    card_description: "Define Income and Expense Categories",
    card_description_suffix: "to keep your income and expenses organized.",
    income_categories: "Income Categories",
    expense_categories: "Expense Categories",
    click_to_edit: "(Click on the category name to edit)",
    category_name: "Category name",
    category_item: "Item",
    category_subitem_optional: "Sub-item (optional)",
    add_income_category: "Add income category",
    add_expense_category: "Add expense category",
    save: "Save",
    empty_state_title: "Start with a category template",
    empty_state_description: "We will create default categories for your organization.",
    initialize_template: "Initialize categories",
  },
  es: {
    title: "Categorías",
    description: "Gestiona categorías de ingresos y gastos para organizar transacciones",
    card_title: "Categorizar transacciones",
    card_description: "Define categorías de ingresos y gastos",
    card_description_suffix: "para mantener tus ingresos y gastos organizados.",
    income_categories: "Categorías de Ingresos",
    expense_categories: "Categorías de Gastos",
    click_to_edit: "(Haz clic en el nombre de la categoría para editar)",
    category_name: "Nombre de la categoría",
    category_item: "Elemento",
    category_subitem_optional: "Subelemento (opcional)",
    add_income_category: "Añadir categoría de ingresos",
    add_expense_category: "Añadir categoría de gastos",
    save: "Guardar",
    empty_state_title: "Empieza con un template de categorías",
    empty_state_description: "Crearemos categorías predeterminadas para tu organización.",
    initialize_template: "Inicializar categorías",
  },
  et: {
    title: "Kategooriad",
    description: "Halda tulu- ja kulukategooriaid tehingute korraldamiseks",
    card_title: "Kategoriseeri tehingud",
    card_description: "Määra tulu- ja kulukategooriad",
    card_description_suffix: "et hoida sissetulekud ja kulud korras.",
    income_categories: "Sissetulekute kategooriad",
    expense_categories: "Kulude kategooriad",
    click_to_edit: "(Klõpsa kategooria nimel, et muuta)",
    category_name: "Kategooria nimi",
    category_item: "Element",
    category_subitem_optional: "Alamelement (valikuline)",
    add_income_category: "Lisa tulu kategooria",
    add_expense_category: "Lisa kulu kategooria",
    save: "Salvesta",
    empty_state_title: "Alusta kategooriate malliga",
    empty_state_description: "Loome vaikekategooriad sinu organisatsiooni jaoks.",
    initialize_template: "Loo kategooriad",
  },
  de: {
    title: "Kategorien",
    description: "Verwalten Sie Einnahmen- und Ausgabenkategorien zur Organisation von Transaktionen",
    card_title: "Transaktionen kategorisieren",
    card_description: "Definieren Sie Einnahmen- und Ausgabenkategorien",
    card_description_suffix: "um Einnahmen und Ausgaben zu organisieren.",
    income_categories: "Einnahmenkategorien",
    expense_categories: "Ausgabenkategorien",
    click_to_edit: "(Klicken Sie auf den Kategorienamen zum Bearbeiten)",
    category_name: "Kategoriename",
    category_item: "Element",
    category_subitem_optional: "Unterelement (optional)",
    add_income_category: "Einnahmenkategorie hinzufügen",
    add_expense_category: "Ausgabenkategorie hinzufügen",
    save: "Speichern",
    empty_state_title: "Mit einer Kategorienvorlage starten",
    empty_state_description: "Wir erstellen Standardkategorien für Ihre Organisation.",
    initialize_template: "Kategorien initialisieren",
  },
  fr: {
    title: "Catégories",
    description: "Gérez les catégories de revenus et dépenses pour organiser les transactions",
    card_title: "Catégoriser les transactions",
    card_description: "Définissez des catégories de revenus et de dépenses",
    card_description_suffix: "pour garder vos finances organisées.",
    income_categories: "Catégories de Revenus",
    expense_categories: "Catégories de Dépenses",
    click_to_edit: "(Cliquez sur le nom de la catégorie pour modifier)",
    category_name: "Nom de la catégorie",
    category_item: "Élément",
    category_subitem_optional: "Sous-élément (optionnel)",
    add_income_category: "Ajouter une catégorie de revenus",
    add_expense_category: "Ajouter une catégorie de dépenses",
    save: "Enregistrer",
    empty_state_title: "Commencer avec un modèle de catégories",
    empty_state_description: "Nous créerons des catégories par défaut pour votre organisation.",
    initialize_template: "Initialiser les catégories",
  },
  it: {
    title: "Categorie",
    description: "Gestisci categorie di entrate e spese per organizzare le transazioni",
    card_title: "Categoriza le transazioni",
    card_description: "Definisci categorie di entrate e spese",
    card_description_suffix: "per mantenere entrate e spese organizzate.",
    income_categories: "Categorie di Entrate",
    expense_categories: "Categorie di Spese",
    click_to_edit: "(Clicca sul nome della categoria per modificare)",
    category_name: "Nome categoria",
    category_item: "Elemento",
    category_subitem_optional: "Sotto-elemento (opzionale)",
    add_income_category: "Aggiungi categoria di entrate",
    add_expense_category: "Aggiungi categoria di spese",
    save: "Salva",
    empty_state_title: "Inizia con un modello di categorie",
    empty_state_description: "Creeremo categorie predefinite per la tua organizzazione.",
    initialize_template: "Inizializza categorie",
  },
  nl: {
    title: "Categorieën",
    description: "Beheer inkomsten- en uitgavencategorieën om transacties te ordenen",
    card_title: "Transacties categoriseren",
    card_description: "Definieer inkomsten- en uitgavencategorieën",
    card_description_suffix: "om inkomsten en uitgaven georganiseerd te houden.",
    income_categories: "Inkomstencategorieën",
    expense_categories: "Uitgavencategorieën",
    click_to_edit: "(Klik op de categorienaam om te bewerken)",
    category_name: "Categorienaam",
    category_item: "Item",
    category_subitem_optional: "Subitem (optioneel)",
    add_income_category: "Inkomstencategorie toevoegen",
    add_expense_category: "Uitgavencategorie toevoegen",
    save: "Opslaan",
    empty_state_title: "Begin met een categorietemplate",
    empty_state_description: "We maken standaardcategorieën voor je organisatie.",
    initialize_template: "Categorieën initialiseren",
  },
  sv: {
    title: "Kategorier",
    description: "Hantera inkomst- och utgiftskategorier för att organisera transaktioner",
    card_title: "Kategorisera transaktioner",
    card_description: "Definiera inkomst- och utgiftskategorier",
    card_description_suffix: "för att hålla intäkter och utgifter organiserade.",
    income_categories: "Inkomstkategorier",
    expense_categories: "Utgiftskategorier",
    click_to_edit: "(Klicka på kategorinamnet för att redigera)",
    category_name: "Kategorinamn",
    category_item: "Post",
    category_subitem_optional: "Underpost (valfritt)",
    add_income_category: "Lägg till inkomstkategori",
    add_expense_category: "Lägg till utgiftskategori",
    save: "Spara",
    empty_state_title: "Börja med en kategorimall",
    empty_state_description: "Vi skapar standardkategorier för din organisation.",
    initialize_template: "Initiera kategorier",
  },
  da: {
    title: "Kategorier",
    description: "Administrer indtægts- og udgiftskategorier for at organisere transaktioner",
    card_title: "Kategoriser transaktioner",
    card_description: "Definér indtægts- og udgiftskategorier",
    card_description_suffix: "for at holde indtægter og udgifter organiseret.",
    income_categories: "Indkomstkategorier",
    expense_categories: "Udgiftskategorier",
    click_to_edit: "(Klik på kategorinavnet for at redigere)",
    category_name: "Kategorinavn",
    category_item: "Element",
    category_subitem_optional: "Underelement (valgfri)",
    add_income_category: "Tilføj indkomstkategori",
    add_expense_category: "Tilføj udgiftskategori",
    save: "Gem",
    empty_state_title: "Start med en kategoriskabelon",
    empty_state_description: "Vi opretter standardkategorier for din organisation.",
    initialize_template: "Initialiser kategorier",
  },
  fi: {
    title: "Kategoriat",
    description: "Hallitse tulo- ja menokategorioita tapahtumien järjestämiseksi",
    card_title: "Luokittele tapahtumat",
    card_description: "Määritä tulo- ja menokategoriat",
    card_description_suffix: "jotta tulot ja menot pysyvät järjestyksessä.",
    income_categories: "Tulokategoriat",
    expense_categories: "Kulukategoriat",
    click_to_edit: "(Napsauta kategorian nimeä muokataksesi)",
    category_name: "Kategorian nimi",
    category_item: "Kohde",
    category_subitem_optional: "Alakohde (valinnainen)",
    add_income_category: "Lisää tulokategoria",
    add_expense_category: "Lisää kulukategoria",
    save: "Tallenna",
    empty_state_title: "Aloita kategoriapohjalla",
    empty_state_description: "Luomme oletuskategoriat organisaatiollesi.",
    initialize_template: "Alusta kategoriat",
  },
};
